module.exports = __webpack_public_path__ + "media/assets/images/layout/sample-profile-1b17e6209285dab1b6e6dc266ac29558.jpg";